/* eslint-disable import/no-anonymous-default-export */
export default {
  primary: "var(--ant-primary-color)",
  primaryTextColor: "var(--ant-success-color)",
  primaryHover: "#037f6f",
  secondary: "#002d2f",
  warning: "#D60B52"
};
